import { render, staticRenderFns } from "./tmariko-video-player.vue?vue&type=template&id=60fd9102&scoped=true&"
import script from "./tmariko-video-player.vue?vue&type=script&lang=js&"
export * from "./tmariko-video-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd9102",
  null
  
)

export default component.exports